<template>
  <div>
    <ErrorBox
      v-if="errorBoxVisible"
      :errorType="errorType"
      :kind="kind"
      :maxLines="maxLines"
    />

    <DownloadSpreadsheet
      v-if="downloadSpreadsheetVisible"
      :kind="kind"
      :maxLines="maxLines"
      :invalidFileType="error.invalidFileType"
      :oldTemplateTipVisible="oldTemplateTipVisible"
    />

    <UploadBox
      :kind="kind"
      :maxLines="maxLines"
      :maxLinesTitle="errorType === 'maxLines'"
      :worksheetTarget="worksheetTarget"
      :supportedFileTypes="supportedFileTypes"
      @change="handleChangeUploadBox({})"
      @success="handleSuccessUploadBox"
      @error="handleErrorUploadBox"
    />
  </div>
</template>

<script>
import uploadBox from 'mixins/uploadBox'
import ErrorBox from 'components/bulkImport/stepOne/ErrorBox'
import DownloadSpreadsheet from 'components/bulkImport/stepOne/DownloadSpreadsheet'
import UploadBox from 'components/bulkImport/stepOne/UploadBox'

export default {
  name: 'StepOne',
  components: {
    ErrorBox,
    DownloadSpreadsheet,
    UploadBox
  },
  props: {
    kind: {
      type: String
    },
    maxLines: {
      type: Number
    },
    worksheetTarget: {
      type: [String, Array]
    },
    supportedFileTypes: {
      type: Array
    }
  },
  mixins: [uploadBox],
  computed: {
    downloadSpreadsheetVisible () {
      return !this.error.maxLines && !this.error.invalidFileType && !this.error.emptyFile
    },

    errorType () {
      return Object.keys(this.error).find(key => this.error[key])
    },

    errorBoxVisible () {
      return this.errorType === 'maxLines' || this.errorType === 'emptyFile'
    },

    oldTemplateTipVisible () {
      return this.errorType === 'oldTemplate'
    }
  }
}
</script>
